(function() {
    'use strict';
    /*
     * Copyright (c) 2014-2017 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .service('PrescriptionChooserConfig', PrescriptionChooserConfig);

    PrescriptionChooserConfig.$inject = ['$filter', 'ItemChooserSvc', 'ItemChooserConstants'];

    function PrescriptionChooserConfig($filter, ItemChooserSvc, ItemChooserConstants) {
        var SAVE_STATE = 'ihh.chooser-state.prescriptions';

        var localItems = [];

        var config = ItemChooserSvc.createConfig(SAVE_STATE);

        config.setItemProperties('Prescription Template', 'Prescription Templates', false);
        config.addSortOption(ItemChooserConstants.SORT_KIND_ALPHA, 'Title', 'title');

        config.setLocalManipulationMode(true);
        config.setCustomTemplate('scrip-template-chooser/protocol-template-item.tpl.html');

        // This is a unique use of the item-chooser.  We are overriding the fundamental query function to instead use the prescription
        // templates from a protocol.
        config.nextPage = function() {
            // as-sortable doesn't work with orderBy on ng-repeat, so we must do such before supplying the items to as-sortable
            config.items = $filter('chooserFilter')(localItems, config);

            config.items.allItemsRetrieved = true;
            config.items.$resolved = true;
            config.items.$promise = {};
        };

        config.setSearchable(false);

        this.init = function(prescriptionTemplates) {
            localItems = angular.isArray(prescriptionTemplates) ? prescriptionTemplates : [];

            config.recallState();

            config.nextPage();

            return config;
        };
    }
})();